import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(others)/privacy-policy/page.tsx");
